import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { DetailsHeader, Icon, IDetailsListStyles, Text } from 'office-ui-fabric-react';
import i18next, { t } from 'i18next';

export interface ICollaboratorViewDetailListItem {
  key: number;
  name: string;
  value: number;
}

export interface ICollaboratorViewDetailListState {
  items: ICollaboratorViewDetailListItem[];
}

interface CollaboratorViewDetailListProps {
  data?: any[];
}

export class CollaboratorViewDetailList extends React.Component<
  CollaboratorViewDetailListProps,
  ICollaboratorViewDetailListState
> {
  private _allItems: any[];
  private _columns: IColumn[];

  constructor(props: CollaboratorViewDetailListProps) {
    super(props);

    this._allItems = props.data ?? [];

    this._columns = [
      {
        key: "Proyecto",
        name: t("Proyecto"),
        fieldName: "pro_nombre",
        minWidth: 200,
        maxWidth: 400,
        isResizable: true,
      },
      {
        key: "Actividades totales",
        name: t("Totales"),
        fieldName: "cant_actividades",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                style={{ display: "block" }}
              >
                {t("Actividades")}
              </Text>
              <Text className="fw-500" style={{ display: "block" }}>
                {t("Totales")}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Actividades confirmadas",
        name: t("Confirmadas"),
        fieldName: "participa",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                style={{ display: "block" }}
              >
                {t("Actividades")}
              </Text>
              <Text className="fw-500" style={{ display: "block" }}>
                {t("Confirmadas")}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Actividades declinadas",
        name: t("Declinadas"),
        fieldName: "declina",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                style={{ display: "block" }}
              >
                {t("Actividades")}
              </Text>
              <Text className="fw-500" style={{ display: "block" }}>
                {t("Declinadas")}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Actividades pendientes",
        name: t("Actividades Pendientes de Aceptacion"),
        fieldName: "tag_pending",
        minWidth: 150,
        maxWidth: 150,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                styles={{ root: { whiteSpace: "normal", textAlign: "center" } }}
              >
              {t('Actividades Pendientes de Aceptacion')}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Horas confirmadas",
        name: t("Confirmadas"),
        fieldName: "horas_participa",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                style={{ display: "block" }}
              >
                {t("Horas")}
              </Text>
              <Text className="fw-500" style={{ display: "block" }}>
                {t("Confirmadas")}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Horas pendientes",
        name: t("Horas Pendientes de Aceptacion"),
        fieldName: "horas_tag_pending",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                styles={{ root: { whiteSpace: "normal", textAlign: "center" } }}
              >
                {t("Horas Pendientes de Aceptacion")}
              </Text>
            </span>
          );
        },
      },
      {
        key: "Documentos totales",
        name: t("Totales"),
        fieldName: "cant_docs",
        minWidth: 125,
        maxWidth: 125,
        isResizable: true,
        onRenderHeader: (item: any) => {
          return (
            <span style={{ textAlign: "center" }}>
              <Text
                className="fw-500"
                variant="medium"
                style={{ display: "block" }}
              >
                {t("Documentos")}
              </Text>
              <Text className="fw-500" style={{ display: "block" }}>
                {t("Totales")}
              </Text>
            </span>
          );
        },
      },
      // {
      //   key: 'Documentos pendientes',
      //   name: t('Pendientes'),
      //   fieldName: 'doc_pending',
      //   minWidth: 125,
      //   maxWidth: 125,
      //   isResizable: true,
      //   onRenderHeader: (item: any) => {
      //     return (
      //       <span style={{ textAlign: 'center' }}>
      //         <Text className="fw-500" variant="medium" style={{ display: 'block' }}>
      //           {t('Documentos')}
      //         </Text>
      //         <Text className="fw-500" style={{ display: 'block' }}>
      //           {t('Pendientes')}
      //         </Text>
      //       </span>
      //     );
      //   },
      // },
    ];

    this.state = {
      items: this._allItems,
    };
  }

  componentDidUpdate(prevProps: CollaboratorViewDetailListProps) {
    if (prevProps.data !== this.props.data) {
      this._allItems = this.props.data ?? [];
      this.setState({
        items: this._allItems,
      });
    }
  }

  public render(): JSX.Element {
    const { items } = this.state;

    return (
      <div>
        <DetailsList
          items={items}
          columns={this._columns}
          setKey="set"
          layoutMode={DetailsListLayoutMode.justified}
          selectionMode={SelectionMode.none}
          ariaLabelForSelectionColumn="Toggle selection"
          ariaLabelForSelectAllCheckbox="Toggle selection for all items"
          checkButtonAriaLabel="select row"
          onItemInvoked={this._onItemInvoked}
          onShouldVirtualize={() => false}
          className="two-line-header-list"
        />
      </div>
    );
  }

  private _onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text: string
  ): void => {
    this.setState({
      items: text
        ? this._allItems.filter((i) => i.name.toLowerCase().indexOf(text) > -1)
        : this._allItems,
    });
  };

  private _onItemInvoked = (item: ICollaboratorViewDetailListItem): void => {
    alert(`Item invoked: ${item.name}`);
  };
}
